<template>
  <div class="maindiv news-wrap">
    <div class="list-bg news-bg"></div>
    <div class="discs list htmldiv">
      <div class="localdiv tright pr15 tc6 pt25 pb15">
        <span class="fs24 fl tc3 lborder prelative pl25 lh10">专业</span>
        <div class="pt10">
          当前位置:
          <router-link to="/">学校首页 > </router-link>
          <router-link to="/disc">专业</router-link>
        </div>
      </div>
      <div class="cont pt50 pl15" v-if="list">
        <disc-item v-for="(item,index) in list" :item="item" :index="index" :key="item.id" :num="perPage * (page - 1) + index + 1"/>
      </div>
      <pagec :page="page" :total="total" :size="perPage" @get-data="getData" :key="'00'"/>
    </div>

  </div>
</template>

<script>
import Pagec from "../../components/un_index/Page";
import DiscItem from "../../components/index/DiscItem";
export default {
  name: "disc",
  components:{
    Pagec,
    DiscItem
  },
  data(){
    return {
      perPage:10,
      page:1,
      list:[],
      msg:'加载中……',
      total:0,
    }
  },
  created() {
    this.getData(1);
  },
  methods:{
    clearList(){
    },
    getData(page){
      this.page = page;
      var getParam = {}
      var id = this.$params.column[0]['children'][0]['params']['id']
      getParam['category_id'] = id
      getParam['perPage'] = this.perPage
      getParam['page'] = this.page
      this.$request.get('article/list',getParam,response => {
        if(response.status == 200 && response.data.data.data.length > 0){
          let res = response.data.data.data
          this.list = res
          this.total = response.data.data.total
        }else{
          this.msg = '无数据';
        }
        console.log(this.list)
      },error => {
        console.log(error)
      })
    },
  },
}
</script>

<style scoped>
  .news-bg{background: url(../../assets/images/index_05_01.jpg) no-repeat center top;}
  .discs{marign-left: 11px;}
  .discs .sdiv:hover{color: #b02e31;}
  .discs .sdiv:hover img{transform: scale(1.1);}
  .discs .igs{width: 130px;height: 70px;}
  .discs .txt{width: 320px;}
  .discs .nm{height: 28px;}
  .discs .ot{height: 40px;}
  .discs.list{width: 1080px;}
  .discs .cont{padding-top: 50px;}
  .discs .sdiv{margin-bottom: 50px;}
  .discs .sdiv .txt{width: 360px;}
  .discs .sdiv:nth-child(2n){margin-left: 60px;}
</style>



// WEBPACK FOOTER //
// src/pages/index/disc.vue